import { render, staticRenderFns } from "./parentDownLoad.vue?vue&type=template&id=30489d30&"
import script from "./parentDownLoad.vue?vue&type=script&lang=js&"
export * from "./parentDownLoad.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports